import {compose} from 'redux';
import App from './App-redux';
import providerRedux from '../hoc/providerRedux';

export default compose(
  providerRedux,
)(App);
